/**
 * Número de cadastro do livro: o mesmo número da etiqueta do exemplar físico, usado para achá-lo
 * na estante. Regras de exibição e de busca ficam aqui, fora da tela, para serem testadas em Node
 * puro (ver numeroCadastro.test.mjs).
 */

/** Mostra com ao menos 4 dígitos ("0412"); números maiores aparecem inteiros. */
export function formatarNumeroCadastro(numero: number): string {
  return String(numero).padStart(4, "0");
}

/**
 * `true` quando o texto da pesquisa bate com o número do livro. Aceita "412", "0412", "nº 0412"
 * e pedaços ("41"). Texto sem nenhum dígito nunca bate (a busca por título e autor segue à parte).
 */
export function numeroCorrespondeBusca(numero: number | null | undefined, termo: string): boolean {
  if (numero == null) return false;
  const digitos = termo.replace(/\D/g, "");
  if (!digitos) return false;
  return formatarNumeroCadastro(numero).includes(digitos);
}

/** Próximo número livre: o maior já usado (inclusive por livros excluídos) mais um. */
export function proximoNumeroCadastro(maiorNumeroUsado: number | null | undefined): number {
  return (maiorNumeroUsado ?? 0) + 1;
}
